var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9998 48V48.13C91.9741 56.8213 89.375 65.3102 84.5303 72.526C79.6857 79.7418 72.8126 85.3612 64.7779 88.6754C56.7433 91.9895 47.9072 92.8499 39.3841 91.148C30.8611 89.4461 23.033 85.2582 16.8873 79.1125C10.7417 72.9668 6.55372 65.1387 4.85183 56.6157C3.14994 48.0927 4.01032 39.2565 7.32445 31.2219C10.6386 23.1873 16.258 16.3141 23.4738 11.4695C30.6896 6.62484 39.1786 4.02572 47.8698 4H47.9998C49.0598 4 50.1098 4 51.1598 4.12C52.8784 4.2403 54.5882 4.46404 56.2798 4.79C59.0504 5.31492 61.7633 6.10867 64.3798 7.16C69.8708 9.3682 74.8615 12.6583 79.055 16.8347C83.2485 21.011 86.5591 25.9881 88.7898 31.47C89.8715 34.1291 90.6855 36.8894 91.2198 39.71C91.5451 41.4186 91.7689 43.1449 91.8898 44.88C91.9998 45.92 91.9998 47 91.9998 48Z",
    fill: "#075382"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9994 44.5V44.62C90.9816 52.4306 88.6503 60.0609 84.2999 66.5477C79.9494 73.0346 73.7748 78.0873 66.5553 81.0681C59.3358 84.0488 51.3951 84.8241 43.7355 83.2959C36.0758 81.7678 29.0405 78.0048 23.5175 72.4818C17.9946 66.9589 14.2316 59.9236 12.7034 52.2639C11.1753 44.6042 11.9505 36.6635 14.9313 29.4441C17.9121 22.2246 22.9648 16.0499 29.4516 11.6995C35.9385 7.34905 43.5688 5.0178 51.3794 5H51.4994C52.4994 5 53.3894 5 54.3394 5.11C55.88 5.21747 57.4128 5.41783 58.9294 5.71C60.7784 6.0623 62.5997 6.54687 64.3794 7.16C69.8703 9.3682 74.8611 12.6583 79.0546 16.8347C83.2481 21.011 86.5586 25.9881 88.7894 31.47C89.4329 33.2926 89.9377 35.1613 90.2994 37.06C90.5915 38.5934 90.7919 40.1428 90.8994 41.7C90.9994 42.63 90.9994 43.57 90.9994 44.5Z",
    fill: "#116D9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6602 21.9299C75.7336 23.0386 76.7356 24.2143 77.6602 25.4499",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12C62.23 13.225 66.2156 15.1738 69.78 17.76",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7206 41.97H29.6406V65.42H37.7206V41.97Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.411 52.2202C66.416 50.8697 66.2412 49.5245 65.891 48.2202C65.101 45.4202 63.361 42.4502 59.571 41.7102C54.901 40.8102 51.831 42.4502 49.571 45.0902V42.0002H41.541V65.4102H49.621V52.5002C49.621 51.5002 49.671 47.5002 54.111 47.5902C58.261 47.7102 58.431 51.2402 58.441 54.4902V65.4102H66.371L66.411 52.2202Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6801 38.7801C35.9444 38.7801 37.7801 36.9444 37.7801 34.6801C37.7801 32.4157 35.9444 30.5801 33.6801 30.5801C31.4157 30.5801 29.5801 32.4157 29.5801 34.6801C29.5801 36.9444 31.4157 38.7801 33.6801 38.7801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f33e81dbee7a68432ab34f19dec5314f.svg";
export { ForwardRef as ReactComponent };